import React, { useState } from 'react';
import { Images, PermissionList, RolePermission, useModal } from 'utils';
import { MinLoader } from '../loader';
import { CsvService } from 'store';
import { DownloadPayrollCsv, DownloadPendingClaims, DownloadBillingInvoice } from './csv';
import { DownloadClaimPaymentCsv } from './csv/downloadClaimPaymentCsv';
import { DownloadScheduleCsv } from './csv/downloadScheduleCsv';
import { DownloadClientCsv } from './csv/downloadClientCsv';
import { DownloadSessionCsv } from './csv/downloadSessionCsv';
import { SimpleTooltip } from '../tooltip';

export const DownloadCsv = ({ type, fromModal, status, params, mimeType = 'csv', permissions }) => {
    const [load, setLoad] = useState(false);
    const { open } = useModal();

    const handleDownload = async () => {
        let response = '';

        if (fromModal) {
            if (type === 'activePayroll') {
                open(<DownloadPayrollCsv status={'ACTIVE'} />);
            }
            if (type === 'passivePayroll') {
                open(<DownloadPayrollCsv status={'PROCESSED'} />);
            }
            if (type === 'pendingClaims' || type === 'billedClaims' || type === 'billableAppt' || type === 'completedClaims') {
                open(<DownloadPendingClaims type={type} />);
            }
            if (type === 'billingInvoice') {
                open(<DownloadBillingInvoice />);
            }
            if (type === 'claimPayment') {
                open(<DownloadClaimPaymentCsv status={status} />);
            }
            if (type === 'schedule') {
                open(<DownloadScheduleCsv />);
            }
            if (type === 'clientNotes') {
                open(<DownloadClientCsv />);
            }
            if (type === 'goalSession') {
                open(<DownloadSessionCsv />);
            }
        } else {
            setLoad(true);
            try {
                if (type === 'staff') {
                    response = await CsvService.getStaffCsv();
                }
                if (type === 'client') {
                    response = await CsvService.getClientCsv();
                }
                if (type === 'schedule') {
                    response = await CsvService.getScheduleCsv();
                }
                if (type === 'fundingSource') {
                    response = await CsvService.getFundingSourceCsv();
                }
                if (type === 'invoicePayment') {
                    response = await CsvService.getInvoicePaymentCsv();
                }
                if (type === 'apptSession') {
                    response = await CsvService.apptSessionCsv(params);
                }
                if (type === 'apptSessionNote') {
                    response = await CsvService.apptSessionNoteCsv(params);
                }

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${type}.${mimeType}`);
                document.body.appendChild(link);
                link.click();
                setLoad(false);
            } catch (e) {
                setLoad(false);
            }
        }
    };

    return (
        <>
            {RolePermission(permissions ? permissions : [PermissionList.REPORT_MANAGE?.code]) && (
                <SimpleTooltip title="Download CSV" placement="top">
                    <button
                        onClick={handleDownload}
                        className={'download-csv-btn-small'}
                    >
                        {load ? (
                            <MinLoader margin={'0'} color={'#4B5C68'} />
                        ) : (
                            <>
                                <img src={Images.downloadCloud} alt="" />
                            </>
                        )}
                    </button>
                </SimpleTooltip>
            )}
        </>
    );
};
